<template>
  <header>
    <div class="header-main width_fixed">
      <h1 class="logo" @click="goHome">
        <router-link to="/home">
          <img src="@/assets/img/pc/logo.png">
        </router-link>
        <span>&nbsp;&nbsp;|&nbsp;&nbsp;让Business更美好，一点点</span>
      </h1>
      <ul class="nav">
        <router-link to="/" tag="li" :class="{'active':this.$route.name=='home'}">首页</router-link>
        <router-link to="/about" tag="li" :class="{'active':this.$route.name=='about'}">关于霖梓</router-link>
        <router-link to="/business" tag="li" :class="{'active':this.$route.name=='business'}">业务纵横</router-link>
        <router-link to="/contact" tag="li" :class="{'active':this.$route.name=='contact'}">联系我们</router-link>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      active: 'home'
    }
  },
  mounted () {
  },
  methods: {
    goHome() {
      this.$router.push('/home')
    }
  }
}
</script>

<style lang="less">
  header {
    width: 100%;
    border-bottom: 1px solid rgba(255,255,255,0.13);
    position: absolute;
    z-index: 996;
    .header-main {
      line-height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo {
        a {
          vertical-align: middle;
        }
        img {
          width: 142px;
          vertical-align: middle;
        }
        span {
          color: #ccc;
          font-weight: 100;
          font-size: 12px;
          vertical-align: middle;
        }
      }
      .nav {
        display: flex;
        justify-content: space-between;
        li {
          margin-left: 20px;
          padding: 0 12px;
          transition: all .4s;
          position: relative;
          cursor: pointer;
          font-size: 14px;
          color: #fff;
        }
        .active {
          color: #f57319;
        }
        .active::after {
          content: "";
          width: 100%;
          border-bottom: 3px solid #f57319;
          position: absolute;
          left: 0;
          bottom: 0;
        }
        li::after {
          content: "";
          width: 0%;
          border-bottom: 3px solid #f57319;
          position: absolute;
          left: 0;
          bottom: 0;
          transition: width .2s;
        }
        li:hover::after {
          content: "";
          width: 100%;
          border-bottom: 3px solid #f57319;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
  }
</style>
